"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.8 5.7A1.2 1.2 0 0 1 7 4.5h5.455c2.408 0 4.381 1.936 4.381 4.35 0 .949-.304 1.824-.82 2.536A4.34 4.34 0 0 1 18.2 15.15c0 2.414-1.973 4.35-4.382 4.35H7a1.2 1.2 0 0 1-1.2-1.2zm2.4 7.5v3.9h5.618c1.106 0 1.982-.884 1.982-1.95s-.876-1.95-1.982-1.95zm0-2.4h4.255c1.105 0 1.981-.884 1.981-1.95S13.56 6.9 12.455 6.9H8.2z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=BoldIcon24.js.map